import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EnvironmentConfigService } from '../../../common/environment-config.service';
import { TimerService } from '../../../common/timer.service';
import { ButtonWithCooldownModel } from './button-with-cooldown.model';

@Component({
  selector: 'app-button-with-cooldown',
  templateUrl: './button-with-cooldown.component.html',
  styleUrl: './button-with-cooldown.component.scss'
})
export class ButtonWithCooldownComponent implements OnInit {

  @Input()
  attributes!: ButtonWithCooldownModel;
  @Output()
  clickHandler = new EventEmitter<void>;
  initialTimerValueInSeconds: number;

  constructor(protected timerService: TimerService, protected environmentConfigService: EnvironmentConfigService) {
    this.initialTimerValueInSeconds = parseInt(environmentConfigService.getEnvConfig().clientCooldownTimer);
  }

  ngOnInit(): void {
    this.timerService.registerTimer(this.attributes.name, this.initialTimerValueInSeconds);
  }

  onClick() {
    if (this.attributes.withTimer) {
      this.timerService.startTimer(this.attributes.name, this.initialTimerValueInSeconds, this.clickHandler);
    } else {
      this.clickHandler.emit();
    }
  }
}
